import { SnackBarProps } from 'components/UI/SnackBar/SnackBar';

export type Snack =
  | Omit<SnackBarProps, 'label' | 'action' | 'duration' | 'visible'>
  | Omit<SnackBarProps, 'visible'>;
export type SnackWithType = Snack & { type: SnackType };

export enum SnackType {
  BASE = 'base',
  SURVEY = 'survey'
}

export interface SnacksState {
  data: SnackWithType[];
  closing: boolean;
}
